"use client"

import { EndpointSetting } from "@/constants/app/type";
import { HotelCity, HotelState } from "../type";

export const callbackCities: EndpointSetting['caller'] = (
  state: HotelState,
  action: any,
  endpointName: any
) => {
  state.hotels_cities.loading = false
  state.hotels_cities.called = true
  state.hotels_cities.error = null

  if (!state.hotels_cities.primaryKeys) {
    state.hotels_cities.primaryKeys = []
  }

  for (let i = 0; i < action.payload.length; i++) {
    const city: HotelCity = action.payload[i];
    state.hotels_cities.data[city.cityId] = city
    if ((state.hotels_cities.primaryKeys as any).indexOf(city.cityId) < 0) {
      (state.hotels_cities.primaryKeys as any).push(city.cityId)
    }
  }
}